import { HttpHeaders } from "../core/http";

export const globalHeaders: HttpHeaders = { "Content-Type": "application/json" };

export function setGlobalHeader(name: string, value: string): void {
    globalHeaders[name] = value;
}

function isValidHttpCode(code: number): boolean {
    return code >= 200 && code < 400;
}

export const http = {
    isValidHttpCode,
};
